#@import Booking.Presenters.PartyPicker
#@import Booking.Views.Picker
#@import Booking.Views.PartySizes
#@export Booking.Views.PartySizePicker

class Booking.Views.PartySizePicker extends Booking.Views.Picker

  presenter: Booking.Presenters.PartyPicker

  contentView: Booking.Views.PartySizes

  templateName: 'partysizepicker'

  attributes: ->
    'data-bhw': "#{Booking.bhw}PartySizes"

  styleClassName: 'party-sizes'

  setSelection: (partySize) ->
    @model.setSelectedPartySize(partySize.getPartySize())

  canRender: ->
    @model.requirePartySize()

  selected: ->
    @model.getSelectedPartySize()


